import { render, staticRenderFns } from "./GlobalMap.vue?vue&type=template&id=90880e24&"
import script from "./GlobalMap.vue?vue&type=script&lang=js&"
export * from "./GlobalMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports